"use client";

import Image from "next/image";
import clsx from "clsx";
import { companies, type PillarKey } from "@/data/companies";

type Props = {
  className?: string;
  title?: string;
  showTitle?: boolean;
  pillar?: PillarKey; // filter logos by pillar when provided
};

export default function LogoMarquee({ className = "", title = "Clients & Collaborations", showTitle = true, pillar }: Props) {
  const items = companies
    .filter((c) => (pillar ? c.pillar === pillar : true))
    .map((c) => ({ name: c.name, file: c.logo }))
    // remove duplicates by file
    .filter((v, i, a) => a.findIndex((t) => t.file === v.file) === i);

  // ensure we have enough items to look good by repeating
  const lane = items.length > 0 ? items : [{ name: "ESPNcricinfo", file: "espncricinfo.svg" }];
  const shouldScroll = lane.length >= 4;

  return (
    <section className={clsx("container py-10", className)}>
      {showTitle && <h2 className="section-title text-2xl">{title}</h2>}
      {shouldScroll ? (
        <div className="mt-4 overflow-hidden">
          <div className="marquee flex gap-6">
            <div className="marquee-track flex gap-6">
              {lane.concat(lane).map((l, idx) => (
                <div key={l.file + idx} className="flex items-center justify-center p-3 bg-white border rounded-xl h-16 w-40 shrink-0">
                  <Image
                    src={`/logos/${l.file}`}
                    alt={l.name}
                    width={160}
                    height={48}
                    className="h-8 w-auto object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-4 flex flex-wrap gap-6">
          {lane.map((l) => (
            <div key={l.file} className="flex items-center justify-center p-3 bg-white border rounded-xl h-16 w-40">
              <Image
                src={`/logos/${l.file}`}
                alt={l.name}
                width={160}
                height={48}
                className="h-8 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}


